import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from 'axios';
import config from "../../includes/ConfigFile";
import { useLanguage } from '../../includes/LanguageContext.js';

const Mythology = ({ company }) => {
    const { currentLanguage, selectedLanguage } = useLanguage();
    const [slidesData, setSlidesData] = useState([]);
    const lang = selectedLanguage.id;
    const slug = "mythology";

    const settings = {
        className: "center",
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 4,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    centerPadding: "40px",
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "20px",
                },
            },
        ],
    };

    useEffect(() => {
        const fetchCategoryAndPosts = async () => {
            try {
                const categoryRes = await axios.get(
                    `${config.BASE_URL}api/getCategoryIdBySlug/${slug}/${lang}`
                );
                const categoryId = categoryRes.data.id;

                const postRes = await axios.get(
                    `${config.BASE_URL}/api/GetPosts/${categoryId}/${lang}`
                );
                const extractedData = Object.values(postRes.data);
                setSlidesData(extractedData);
            } catch (error) {
                console.error("Error fetching category/posts:", error);
                setSlidesData([]);
            }
        };

        fetchCategoryAndPosts();
    }, [lang]);

// handel category link jb category name click ho to category page pr jaye
    const [categoryId, setCategoryId] = useState(null); // 👈 NEW

useEffect(() => {
    const fetchCategoryAndPosts = async () => {
        try {
            const categoryRes = await axios.get(
                `${config.BASE_URL}api/getCategoryIdBySlug/${slug}/${lang}`
            );

            const catId = categoryRes.data.id;
            setCategoryId(catId); // 👈 SAVE CATEGORY ID

            const postRes = await axios.get(
                `${config.BASE_URL}/api/GetPosts/${catId}/${lang}`
            );

            const extractedData = Object.values(postRes.data);
            setSlidesData(extractedData);

        } catch (error) {
            console.error("Error fetching category/posts:", error);
            setSlidesData([]);
        }
    };

    fetchCategoryAndPosts();
}, [lang]);    



    return (
        <>
            <section>
                <div className="tw-mt-4 md:tw-mt-10">
                    <div className="tw-flex tw-flex-row">
                        <div className="row align-items-start">
                            <div className="col-md-10">
                                {/* <a href="#" className="heading-title">
                                    <h2>{currentLanguage.homeHeading.mythology}</h2>
                                </a> */}

                                {categoryId ? (
                                    <Link 
                                        to={`/category/${categoryId}/${lang}`} 
                                        className="heading-title"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <h2 style={{ cursor: "pointer" }}>
                                            {currentLanguage.homeHeading.mythology}
                                        </h2>
                                    </Link>
                                ) : (
                                    // <h2>{currentLanguage.homeHeading.horror}</h2>
                                    <Link to={`#`} className="heading-title" style={{ textDecoration: "none" }} >
                                        <h2>{currentLanguage.homeHeading.mythology}</h2>
                                    </Link>
                                )}


                            </div>
                            <div className="col-md-2 d-flex justify-content-end">
                                <a href="#" className="">
                                    <i className="bi bi-chevron-right"></i>
                                </a>
                            </div>
                        </div>

                        <div className="slider-container">
                            {slidesData.length > 1 ? (
                                <Slider {...settings}>
                                    {slidesData.map((slide) => (
                                        <Link to={`/story/${slide.id}`} key={slide.id} className="slide-link">
                                            <div className="slide">
                                                <img
                                                    src={`${config.BASE_URL}/public/uploads/admin/post/${slide.post_image}`}
                                                    alt={slide.post_title}
                                                />
                                                <div className="slide-content">
                                                    <div className="title text-light text-center">{slide.post_title}</div>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </Slider>
                            ) : slidesData.length === 1 ? (
                                <div className="d-flex justify-content-start px-3">
                                    <Link to={`/story/${slidesData[0].id}`} className="slide-link">
                                        <div className="slide" style={{ maxWidth: '250px' }}>
                                            <img
                                                src={`${config.BASE_URL}/public/uploads/admin/post/${slidesData[0].post_image}`}
                                                alt={slidesData[0].post_title}
                                                style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
                                            />
                                            <div className="slide-content text-center mt-2">
                                                <div className="title text-light text-center">{slidesData[0].post_title}</div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ) : (
                                <p>Data is not available please find any one...</p>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Mythology;
